import React from 'react'
import { ModalProps, openModal } from 'sb-modal'
import { date } from 'common/helpers'

import { Box } from 'components/_new/layout'
import Text from 'components/_new/typography/Text/Text'

import messages from './messages'


type ChangeFrequencySuccessModalProps = {
  nextShippingDate: string | { from: string, to: string }
  shippingPeriod: string | number
  onClose?: ModalProps['onClose']
}

export const openChangeFrequencySuccessModal = (props: ChangeFrequencySuccessModalProps) => {
  const { nextShippingDate, shippingPeriod, onClose } = props

  const nextDate = date.formatMonth(nextShippingDate)

  const content = (
    <Box mt={16}>
      <Text
        size="14-16"
        color="gray-50"
        message={messages.hint}
      />
    </Box>
  )

  openModal('alert', {
    title: messages.title,
    text: {
      ...messages.text,
      values: {
        date: nextDate,
        period: shippingPeriod,
      },
    },
    dataTestId: 'changeFrequencySuccessModal',
    content,
    onClose,
  })
}
